
export const URLS = {
  auth: {
    login: 'users/authenticate',
    forgotpassword: 'users/forgot-password/email',
    otpVerfiy: 'users/verify-otp',
    setPassword: 'users/set-password',
    savePatientsx: 'users/save-patients-x',
    saveProvidersX: 'users/save-providers-x',
    saveHospitalsX: 'users/save-hospitals-x',
    userDetails: 'users/userDetails?user_id={id}',
  },
  users: {
    getUsersList: `resource/users`,
    getUsersInfo: `resource/users/{id}`,
    saveUsers: `resource/users`,
    editDeleteUsers: `resource/users/{id}`,
  },
  provider: {
    getProvidersList: `resource/providers`,
    getProvidersFullList: `resource/providers/all`,
    getProvidersInfo: `resource/providers/{id}`,
    saveProviders: `resource/providers`,
    providerinfo: `users/providerinfo`,
    editDeleteProviders: `resource/providers/{id}`,
  },
  unavailability: {
    getUnavailabilityList: `resource/provider_unavailabilities`,
    getUnavailabilityFullList: `resource/provider_unavailabilities/all`,
    getUnavailabilityInfo: `resource/provider_unavailabilities/{id}`,
    saveUnavailability: `resource/provider_unavailabilities`,
    editDeleteUnavailability: `resource/provider_unavailabilities/{id}`,
  },
  customizedAvailability: {
    getCustomizedavailabilityList: `resource/custom_availability_details`,
    getCustomizedavailabilityFullList: `resource/custom_availability_details/all`,
    getCustomizedavailabilityInfo: `resource/custom_availability_details/{id}`,
    saveCustomizedavailability: `resource/custom_availability_details`,
    editDeleteCustomizedavailability: `resource/custom_availability_details/{id}`,
  },
  master: {
    getMasterBySlugFirst: `resource/masters/first?slug={slug}&order_by=name&dir=1&patient_id={patient_id}`,
    getCountryList: `resource/masters/all?slug=country&order_by=name&dir=1`,
    getMasterBySlugList: `resource/masters/all?slug={slug}&order_by={name}&dir=1&patient_id={patient_id}`,
    getMasterByAttrList: `resource/masters/all?attr_slug={slug}&order_by=id&dir=1&with_values={w_val}&patient_id={patient_id}`,
    getSpecialityList: `resource/masters/all?slug=speciality&order_by=name&dir=1&speciality_type={s_type}`,
    getTimezoneList: `resource/timezone/all`,
    getFullList: `resource/masters/all`,
    getList: `resource/masters`,
    getLoginUserInfo: `users/info`,
    getMasterx: `users/get-master-x?slug={slug}&order_by=name&dir=1`,
    getTimezoneX: `users/get-timezone-x`,
    MasterInfo: `resource/masters/{id}`,
  },
  settings: {
    savePassword: `users/change-password`,
    twofa: `users/twofa`,
    communication: `users/communication`,
  },
  account: {
    editUserAccount: `resource/users/{id}`,
    ActivateAccount: `users/activate-accounts-x?token={id}`,
  },
  document: {
    uploadAvatar: `users/uploadAvatar`,
    getFilePath: `get-document-url`,
  },
  consult: {
    getConsultsSummary: `teleconsult/summary`,
    getConsultsPdfSummary: `teleconsult/summaryPdf`,
    getPatientsSummary: `patient/summary`,
    getPatientsPdfSummary: `patient/summaryPdf`,
    getConsultsList: `resource/consults`,
    getConsultsFullList: `resource/consults/all`,
    getConsultsInfo: `resource/consults/{id}`,
    saveConsults: `resource/consults`,
    checkContract: `contract/check?type={type}`,
    editDeleteConsults: `resource/consults/{id}`,
  },
  patient: {
    getPatientsList: `resource/patients`,
    getPatientsFirst: `resource/patients/first`,
    getPatientsFullList: `resource/patients/all`,
    getPatientsInfo: `resource/patients/{id}`,
    savePatients: `resource/patients`,
    editDeletePatients: `resource/patients/{id}`,
  },
  hospital: {
    getHospitalsList: `resource/hospitals`,
    getHospitalsInfo: `resource/hospitals/{id}`,
    saveHospitals: `resource/hospitals`,
    editDeleteHospitals: `resource/hospitals/{id}`,
    getHospitalListAll: `resource/hospitals/all`,
    getHospitalStaffsFullList: `resource/staffs/all`,
  },
  camera: {
    getCamerasList: `resource/cameras`,
    getCamerasInfo: `resource/cameras/{id}`,
    saveCameras: `resource/cameras`,
    editDeleteCameras: `resource/cameras/{id}`,
    getCameraListAll: `resource/cameras/all`,
  },
  hospital_groups: {
    getHospitalGroupsList: `resource/hospital_groups`,
    getHospitalGroupsInfo: `resource/hospital_groups/{id}`,
    saveHospitalGroups: `resource/hospital_groups`,
    editDeleteHospitalGroups: `resource/hospital_groups/{id}`,
    getHospitalGroupsListAll: `resource/hospital_groups/all`,
    getHospitalGroupsFirst: `resource/hospital_groups/first`,
  },
  x_a2z_apis: {
    getProvidersList: `a2z/Provider/{entity}/List`,
    createProviders: `a2z/Provider/{entity}/Create`,
    providerFetch: `a2z/Provider/{entity}/Fetch/{id}`,
    providersUpdate: `a2z/Provider/{entity}/Update/{id}`,
    providersPartialUpdate: `a2z/Provider/{entity}/PartialUpdate/{id}`,
    providersDelete: `a2z/Provider/{entity}/Delete/{id}`,


    getProviderGroupsListAll: `a2z/ProviderGroup/{entity}/getAll`,
    getProviderGroupsList: `a2z/ProviderGroup/{entity}/List`,
    createProviderGroups: `a2z/ProviderGroup/{entity}/Create`,
    providerGroupFetch: `a2z/ProviderGroup/{entity}/Fetch/{id}`,
    providerGroupsUpdate: `a2z/ProviderGroup/{entity}/Update/{id}`,
    providerGroupsPartialUpdate: `a2z/ProviderGroup/{entity}/PartialUpdate/{id}`,
    providerGroupsDelete: `a2z/ProviderGroup/{entity}/Delete/{id}`,

    getMastersList: `a2z/Master/{entity}/getAll?slug={slug}&order_by=name&dir=1`,
    getTimezoneList: `a2z/Timezone/{entity}/getAll`,


    getPatientsList: `a2z/patient/{entity}/List`,
    createPatients: `a2z/patient/{entity}/Create`,
    patientFetch: `a2z/patient/{entity}/Fetch/{id}`,
    patientsUpdate: `a2z/patient/{entity}/Update/{id}`,
    patientsPartialUpdate: `a2z/patient/{entity}/PartialUpdate/{id}`,
    patientsDelete: `a2z/patient/{entity}/Delete/{id}`,

    getUsersList: `a2z/user/{entity}/List`,
    createUsers: `a2z/user/{entity}/Create`,
    userFetch: `a2z/user/{entity}/Fetch/{id}`,
    usersUpdate: `a2z/user/{entity}/Update/{id}`,
    usersPartialUpdate: `a2z/user/{entity}/PartialUpdate/{id}`,
    usersDelete: `a2z/user/{entity}/Delete/{id}`,

    getHospitalListAll: `a2z/Hospital/{entity}/getAll`,
    getHospitalsList: `a2z/Hospital/{entity}/List`,
    createHospitals: `a2z/Hospital/{entity}/Create`,
    hospitalFetch: `a2z/Hospital/{entity}/Fetch/{id}`,
    hospitalsUpdate: `a2z/Hospital/{entity}/Update/{id}`,
    hospitalsPartialUpdate: `a2z/Hospital/{entity}/PartialUpdate/{id}`,
    hospitalsDelete: `a2z/Hospital/{entity}/Delete/{id}`,


    getHospitalGroupsListAll: `a2z/HospitalGroup/{entity}/getAll`,
    getHospitalGroupsList: `a2z/HospitalGroup/{entity}/List`,
    createHospitalGroups: `a2z/HospitalGroup/{entity}/Create`,
    hospitalGroupFetch: `a2z/HospitalGroup/{entity}/Fetch/{id}`,
    hospitalGroupsUpdate: `a2z/HospitalGroup/{entity}/Update/{id}`,
    hospitalGroupsPartialUpdate: `a2z/HospitalGroup/{entity}/PartialUpdate/{id}`,
    hospitalGroupsDelete: `a2z/HospitalGroup/{entity}/Delete/{id}`,

    getContractListAll: `a2z/Contract/{entity}/getAll`,
    getContractList: `a2z/Contract/{entity}/List`,
    createContract: `a2z/Contract/{entity}/Create`,
    ContractFetch: `a2z/Contract/{entity}/Fetch/{id}`,
    ContractUpdate: `a2z/Contract/{entity}/Update/{id}`,
    ContractPartialUpdate: `a2z/Contract/{entity}/PartialUpdate/{id}`,
    ContractDelete: `a2z/Contract/{entity}/Delete/{id}`,
  },
  contract: {
    getContractList: `resource/Contract`,
    getContractFullList: `resource/Contract/all`,
    getContractInfo: `resource/Contract/{id}`,
    saveContract: `resource/Contract`,
    editDeleteContract: `resource/Contract/{id}`,
  },
};
